<ng-container *ngIf="content">
    <div class="topbar-item" data-placement="bottom" ngbTooltip="Informações do Usuário">
        <div class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2" id="kt_quick_user_toggle">
            <ng-container>
                <span class="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">Olá,</span>
            </ng-container>
            <span *ngIf="name" class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
                {{name | firstName}}
            </span>
            <span *ngIf="userName" class="symbol symbol-35 symbol-light-success">
                <span class="symbol-label font-size-h5 font-weight-bold">
                    {{name | firstLetter}}
                </span>
            </span>
        </div>
    </div>
</ng-container>